import type { QueryHookOptions } from "@apollo/client";
import { gql, useLazyQuery, useQuery } from "@apollo/client";

import type { ProductSearchParams } from "@shared/components/CatalogSearch/CatalogSearch";
import type { Brand, Product, Variant } from "@shared/types/graphqlGenerated";

const Sku_Product_Emerson_Query = gql`
  query Sku_Product_Emerson_Query(
    $filters: ProductSearchV2FilterObject
    $variantFilters: VariantFilterObject
    $first: Int
  ) {
    viewer {
      productSearchV2(filters: $filters, first: $first) {
        nodes {
          id
          _legacyId
          name
          slug
          brand {
            id
            name
          }
          variants(filters: $variantFilters) {
            id
            availabilityStatus
            descriptor
            expectedReturnDate
            imageNew
            sku
            emersonVariantId
            wholesalePrice
          }
        }
      }
    }
  }
`;

type ProductSplinter = Pick<Product, "id" | "name" | "slug" | "containsCbd">;

interface EmersonProductSearchResult extends ProductSplinter {
  brand: Brand;
  variants: Variant[];
}

interface SkuProductQueryData {
  viewer: {
    productSearchV2: {
      nodes: EmersonProductSearchResult[];
    };
  };
}

interface ProductSearchVariables extends ProductSearchParams {
  first?: number;
  variantFilters?: {
    query: string;
  };
}

const defaultOptions: QueryHookOptions<SkuProductQueryData, ProductSearchVariables> = {
  variables: {
    first: 1,
  },
};

const useSkuProductQuery = (
  options?: QueryHookOptions<SkuProductQueryData, ProductSearchVariables>
) => {
  return useQuery<SkuProductQueryData, ProductSearchVariables>(Sku_Product_Emerson_Query, options);
};

const useSkuProductLazyQuery = (
  options?: QueryHookOptions<SkuProductQueryData, ProductSearchVariables>
) =>
  useLazyQuery<SkuProductQueryData, ProductSearchVariables>(Sku_Product_Emerson_Query, {
    ...defaultOptions,
    ...options,
    variables: { ...defaultOptions.variables, ...options?.variables },
  });

export type { SkuProductQueryData, EmersonProductSearchResult };

/* eslint-disable @fullscript/gql-no-manual-hook-declaration */
export { useSkuProductQuery, useSkuProductLazyQuery, Sku_Product_Emerson_Query };
